import PromisePolyfill from 'es6-promise';

// If a Promise implementation already exists, use it. Otherwise, use es6-promise
export default (typeof Promise !== 'undefined' && Promise) || PromisePolyfill;
